module.exports = __webpack_public_path__ + "img/54-r.ddd35402.png";